// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root {
  display: inline-block;
  margin: 0 5px 0 0;
  padding: 3px 8px;
  height: 30px;
  line-height: 22px;
  box-sizing: border-box;
  background: none #fdfdfd;
  background: linear-gradient(to bottom, #fdfdfd 0%,#f6f7f8 100%);
  border: 1px solid #999;
  border-radius: 2px;
  color: #333;
  text-decoration: none;
  font-size: inherit;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
}

.root:disabled {
  cursor: not-allowed;
  background: none transparent;
}

.root:disabled > * {
  opacity: .5;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-rte/lib/ui/Button.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,wBAAwB;EACxB,+DAA+D;EAC/D,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb","sourcesContent":[".root {\n  display: inline-block;\n  margin: 0 5px 0 0;\n  padding: 3px 8px;\n  height: 30px;\n  line-height: 22px;\n  box-sizing: border-box;\n  background: none #fdfdfd;\n  background: linear-gradient(to bottom, #fdfdfd 0%,#f6f7f8 100%);\n  border: 1px solid #999;\n  border-radius: 2px;\n  color: #333;\n  text-decoration: none;\n  font-size: inherit;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.root:disabled {\n  cursor: not-allowed;\n  background: none transparent;\n}\n\n.root:disabled > * {\n  opacity: .5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
